import { BOOK } from '../types';

export default {
  state: {
    bookQuery: null,
    languageQuery: null,
    currencyQuery: null,
  },
  getters: {},
  mutations: {
    [BOOK.SET_BOOK_QUERY](state, payload) {
      state.bookQuery = payload;
    },
    [BOOK.SET_LANGUAGE_QUERY](state, payload) {
      state.languageQuery = payload;
    },
    [BOOK.SET_CURRENCY_QUERY](state, payload) {
      state.currencyQuery = payload;
    },
  },
  actions: {},
};
